// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"54ede2ba741881a4","5405":"982a2a40a0080442","5528":"bb316c81c50a5d4c"}[chunkId] + ".css";
};